import _ from 'lodash';
import {
  Alert, Badge, Button, Col, Form, Input, InputNumber, Modal, Row, Spin, Switch, Tree, Upload, message as antMessage,
} from 'antd';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { BreadcrumbLevel } from '../BreadcrumbLevel';
import * as actions from '../../actions';
import { DefinedTerm } from '../elements';
import { withContentLayout } from '../layout/Layout';


const _getTag = (tags, predicate) => (tags ? tags.find(predicate) : null);
const NOTIFICATION_CATS_BASE = [
  {
    fieldSuffix: 'user',
    trueValue: 'organization',
    getTag: tags => _getTag(tags, tag => tag.get('role') === 'smart.user'),
  },
  {
    fieldSuffix: 'constituent',
    trueValue: 'own',
    getTag: tags => _getTag(tags, tag => tag.getIn(['parent', 'role']) === 'organization'),
  },
];

const EXPIRY_UPGRADE_KEYS = [
  'accreditationUpgradeExpiring',
  'accreditationUpgradeExpiredUnconfirmed',
  'accreditationUpgradeExpiredConfirmed',
];

const EXPIRING_DOWNGRADE_KEYS = [
  'accreditationDowngradeExpiring',
  'accreditationInitialExpiring',
];

const EXPIRY_UPGRADE_KEY = 'accreditationUpgradeExpiry';

const EXPIRING_DOWNGRADE_KEY = 'accreditationDowngradeExpiring';


@withContentLayout
class OrgSettingsPageComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.footerRef = React.createRef();
    this.state = {
      showOCG: false,
      showSA: false,
      showQLDBLUECreds: false,
      showQLDBLUEDefaults: false,
      currentType: null,
      OCGCredsSaveClicked: false,
      SACredsSaveClicked: false,
      QLDBLUECredsSaveClicked: false,
      QLDBLUEDefaultsSaveClicked: false,
      QLDBLUEDefaultEmpType: null,
      QLDBLUEDefaultAppType: null,
      QLDBLUEDefaultStateSet: false,
      notificationLogoUrl: null,
      uploadingNotificationLogo: false,
      notificationLogoFileList: [],
      screeningPackageLogoUrl: null,
      uploadingScreeningPackageLogo: false,
      screeningPackageLogoFileList: [],
      useDifferentLogos: false,
      organizationLogoUrl: null,
      uploadingOrganizationLogo: false,
      organizationLogoFileList: [],
    };
  }

  componentWillMount() {
    if (this.props.organizationId) {
      this.props.fetchOrganization(this.props.organizationId);
      this.props.fetchOrganizationEmail(this.props.organizationId);
      this.props.fetchOrganizationSettingsV2(this.props.organizationId);
      this.props.fetchTags(this.props.organizationId);
    }
  }

  getCategories = () => NOTIFICATION_CATS_BASE.map(base => ({
    ...base,
    tag: base.getTag(this.props.tagsItems),
  }))

  componentDidUpdate(prevProps) {
    if (prevProps.organizationId !== this.props.organizationId) {
      this.props.fetchOrganization(this.props.organizationId);
      this.props.fetchOrganizationEmail(this.props.organizationId);
      this.props.fetchOrganizationSettingsV2(this.props.organizationId);
      this.props.fetchTags(this.props.organizationId);
    }
    if (prevProps.organizationData !== this.props.organizationData) {
      const orgData = this.props.organizationData.toJSON();
      this.props.form.setFieldsValue({
        abn: orgData.abn,
        externalIdEnabled: orgData.externalIdEnabled,
        managerEmailEnabled: orgData.managerEmailEnabled,
        ndwsSyncEnabled: !!orgData.ndwsSyncEnabled,
        externalLinkTpl: orgData.externalLinkTpl,
        genaccNotificationEnabled: orgData.genaccNotificationEnabled,
        phoneNumber: orgData.phoneNumber,
        institutionsCredentials: orgData.institutionsCredentials || {},
        saSync: _.get(orgData, 'institutionsCredentials.sa.saSync', false),
      });
    }
    if (prevProps.organizationSettings !== this.props.organizationSettings && this.props.organizationSettings) {
      const orgSettings = this.props.organizationSettings.toJSON();
      const icrNudgeNotification = orgSettings.icrNudgeNotification || {};
      this.props.form.setFieldsValue({
        strictNameMatchingEnabled: orgSettings.nameMatch === 'strict' || false,
        newIcrFormEnabled: !!orgSettings.newIcrFormEnabled,
        agedCareBanningOrderEnabled: !!orgSettings.agedCareBanningOrderEnabled,
        icrNudgeEnabled: icrNudgeNotification.enabled || false,
        icrNudgeIntervalDays: icrNudgeNotification.intervalDays || 3,
        icrNudgeMaxCount: icrNudgeNotification.maxCount || 5,
      });

      // Load logo image from settings
      if (orgSettings.notificationLogo) {
        this.setState({
          notificationLogoUrl: orgSettings.notificationLogo,
          notificationLogoFileList: [{
            uid: '-1',
            name: 'notification-logo',
            status: 'done',
            url: orgSettings.notificationLogo,
          }],
        });
      }

      // Load screening logo image from settings
      if (orgSettings.screeningPackageLogo) {
        this.setState({
          screeningPackageLogoUrl: orgSettings.screeningPackageLogo,
          screeningPackageLogoFileList: [{
            uid: '-2',
            name: 'screening-logo',
            status: 'done',
            url: orgSettings.screeningPackageLogo,
          }],
        });
      }

      // Check if logos are the same or different
      const hasBothLogos = orgSettings.notificationLogo && orgSettings.screeningPackageLogo;
      const hasOnlyOne = (orgSettings.notificationLogo && !orgSettings.screeningPackageLogo)
                         || (!orgSettings.notificationLogo && orgSettings.screeningPackageLogo);
      const areSameLogos = orgSettings.notificationLogo === orgSettings.screeningPackageLogo;

      if (hasBothLogos && areSameLogos) {
        // If both logos exist and are the same, set useDifferentLogos to false and load as organization logo
        this.setState({
          useDifferentLogos: false,
          organizationLogoUrl: orgSettings.notificationLogo,
          organizationLogoFileList: [{
            uid: '-3',
            name: 'organization-logo',
            status: 'done',
            url: orgSettings.notificationLogo,
          }],
        });
      } else if (hasBothLogos && !areSameLogos) {
        // If both logos exist but are different, set useDifferentLogos to true
        this.setState({
          useDifferentLogos: true,
        });
      } else if (hasOnlyOne) {
        // If only one logo is set, set useDifferentLogos to true to show separate logos
        this.setState({
          useDifferentLogos: true,
        });
      }
    }
    if (prevProps.tagsItems !== this.props.tagsItems) {
      const categories = this.getCategories();
      if (categories.every(cat => cat.tag)) {
        const notificationValues = _.fromPairs(categories.map(({ fieldSuffix, tag, trueValue }) => [
          `notify.${fieldSuffix}`,
          Object.entries(tag.get('notifications').toJS())
            .filter(([apiKey, value]) => value === trueValue)
            .map(([apiKey, value]) => {
              if (EXPIRY_UPGRADE_KEYS.indexOf(apiKey) !== -1) {
                return EXPIRY_UPGRADE_KEY;
              }
              if (EXPIRING_DOWNGRADE_KEYS.indexOf(apiKey) !== -1) {
                return EXPIRING_DOWNGRADE_KEY;
              }
              return apiKey;
            })
            .filter(apiKey => apiKey),
        ]));
        this.props.form.setFieldsValue(notificationValues);
      }
    }
  }

  validateLogoFile = file => {
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      antMessage.error('File size must be less than 5MB');
      return false;
    }
    return true;
  }

  uploadNotificationLogo = async file => {
    if (!this.validateLogoFile(file)) {
      return Promise.reject(new Error('File size too large'));
    }
    try {
      this.setState({ uploadingNotificationLogo: true });
      const result = await this.props.uploadOrganizationLogo(file, this.props.organizationId);

      if (result && result.data && result.data.url) {
        this.setState({
          notificationLogoUrl: result.data.url,
          uploadingNotificationLogo: false,
          notificationLogoFileList: [{
            uid: '-1',
            name: file.name,
            status: 'done',
            url: result.data.url,
          }],
        });
        antMessage.success('Logo uploaded successfully');
        return result.data.url;
      }
      throw new Error('Upload failed');
    } catch (error) {
      this.setState({ uploadingNotificationLogo: false });
      antMessage.error('Failed to upload logo');
      throw error;
    }
  }

  handleNotificationLogoUpload = ({ file, onSuccess, onError }) => {
    this.uploadNotificationLogo(file)
      .then(url => {
        onSuccess({ url });
      })
      .catch(error => {
        onError(error);
      });
  }

  handleNotificationLogoRemove = () => {
    Modal.info({
      title: 'Contact Support',
      content: 'Please contact support to remove the notification logo.',
      onOk() {},
    });
    return false;
  }

  uploadScreeningPackageLogo = async file => {
    if (!this.validateLogoFile(file)) {
      return Promise.reject(new Error('File size too large'));
    }
    try {
      this.setState({ uploadingScreeningPackageLogo: true });
      const result = await this.props.uploadOrganizationLogo(file, this.props.organizationId);

      if (result && result.data && result.data.url) {
        this.setState({
          screeningPackageLogoUrl: result.data.url,
          uploadingScreeningPackageLogo: false,
          screeningPackageLogoFileList: [{
            uid: '-2',
            name: file.name,
            status: 'done',
            url: result.data.url,
          }],
        });
        antMessage.success('Screening package logo uploaded successfully');
        return result.data.url;
      }
      throw new Error('Upload failed');
    } catch (error) {
      this.setState({ uploadingScreeningPackageLogo: false });
      antMessage.error('Failed to upload screening package logo');
      throw error;
    }
  }

  handleScreeningPackageLogoUpload = ({ file, onSuccess, onError }) => {
    this.uploadScreeningPackageLogo(file)
      .then(url => {
        onSuccess({ url });
      })
      .catch(error => {
        onError(error);
      });
  }

  handleScreeningPackageLogoRemove = () => {
    Modal.info({
      title: 'Contact Support',
      content: 'Please contact support to remove the screening packages logo.',
      onOk() {},
    });
    return false;
  }

  uploadOrganizationLogo = async file => {
    if (!this.validateLogoFile(file)) {
      return Promise.reject(new Error('File size too large'));
    }
    try {
      this.setState({ uploadingOrganizationLogo: true });
      const result = await this.props.uploadOrganizationLogo(file, this.props.organizationId);

      if (result && result.data && result.data.url) {
        this.setState({
          organizationLogoUrl: result.data.url,
          uploadingOrganizationLogo: false,
          organizationLogoFileList: [{
            uid: '-3',
            name: file.name,
            status: 'done',
            url: result.data.url,
          }],
        });
        antMessage.success('Organization logo uploaded successfully');
        return result.data.url;
      }
      throw new Error('Upload failed');
    } catch (error) {
      this.setState({ uploadingOrganizationLogo: false });
      antMessage.error('Failed to upload organization logo');
      throw error;
    }
  }

  handleOrganizationLogoUpload = ({ file, onSuccess, onError }) => {
    this.uploadOrganizationLogo(file)
      .then(url => {
        onSuccess({ url });
      })
      .catch(error => {
        onError(error);
      });
  }

  handleOrganizationLogoRemove = () => {
    Modal.info({
      title: 'Contact Support',
      content: 'Please contact support to remove the organization logo.',
      onOk() {},
    });
    return false;
  }

  handleToggleDifferentLogos = checked => {
    this.setState({ useDifferentLogos: checked });
  }

  handleSubmit = ev => {
    ev.preventDefault();
    this.props.form.validateFields((errors, values) => {
      if (errors) return;

      this.props.patchOrganization(this.props.organizationId, _.omit(values, ['notify', 'strictNameMatchingEnabled', 'icrNudgeEnabled', 'icrNudgeIntervalDays', 'icrNudgeMaxCount']));

      // Determine which logo URLs to save based on toggle state
      let notificationLogoUrl; let
        screeningPackageLogoUrl;

      if (this.state.useDifferentLogos) {
        // Use separate logos
        notificationLogoUrl = this.state.notificationLogoUrl;
        screeningPackageLogoUrl = this.state.screeningPackageLogoUrl;
      } else {
        // Use the same organization logo for both
        notificationLogoUrl = this.state.organizationLogoUrl;
        screeningPackageLogoUrl = this.state.organizationLogoUrl;
      }

      // Include logo_image and ICR nudge settings in the settings PATCH
      this.props.patchOrganizationSettingsV2(this.props.organizationId, {
        nameMatch: values.strictNameMatchingEnabled ? 'strict' : 'light',
        notificationLogo: notificationLogoUrl,
        screeningPackageLogo: screeningPackageLogoUrl,
        newIcrFormEnabled: values.newIcrFormEnabled,
        agedCareBanningOrderEnabled: !!values.agedCareBanningOrderEnabled,
        icrNudgeNotification: {
          enabled: values.icrNudgeEnabled || false,
          intervalDays: values.icrNudgeIntervalDays || 3,
          maxCount: values.icrNudgeMaxCount || 5,
        },
      });

      for (const { fieldSuffix, tag, trueValue } of this.getCategories()) {
        const fieldValues = values.notify[fieldSuffix];
        const notifications = _.mapValues(
          tag.get('notifications').toJS(),
          (v, k) => (
            fieldValues.indexOf(k) === -1
              ? null
              : trueValue
          ),
        );

        // Expand the single expiry value in the UI into the multiple values
        // that represent expiry (confirmed, unconfirmed, soon)
        const expiryUpgradeIdx = fieldValues.indexOf(EXPIRY_UPGRADE_KEY);
        if (expiryUpgradeIdx !== -1) {
          for (const key of EXPIRY_UPGRADE_KEYS) {
            notifications[key] = trueValue;
          }
        }
        const expiringDowngradeIdx = fieldValues.indexOf(EXPIRING_DOWNGRADE_KEY);
        if (expiringDowngradeIdx !== -1) {
          for (const key of EXPIRING_DOWNGRADE_KEYS) {
            notifications[key] = trueValue;
          }
        }

        this.props.patchTag(tag.get('id'), { notifications });
      }

      const doneEmail = window.SERVER_DATA.allowedStatesForOrgEmails.filter(item => {
        if (values && values[item.type]) {
          return this.props.postOrganizationEmail(this.props.organizationId, { type: item.type });
        }
        return null;
      });

      if (doneEmail) {
        this.props.fetchOrganizationEmail(this.props.organizationId);
      }
    });
  }

  renderNotificationsTree = () => (
    <Tree
      selectable={false}
      checkable
    >
      <Tree.TreeNode title={<strong>New issue present</strong>} key="accreditationDowngrade" checkable={false} />
      <Tree.TreeNode title={<Badge color="yellow" text="New warning" />} key="accreditationDowngradeYellow">
        <Tree.TreeNode title="Expiring soon" key={EXPIRING_DOWNGRADE_KEY} />
        <Tree.TreeNode title="Expired (unconfirmed)" key="accreditationDowngradeExpiredUnconfirmed" />
        <Tree.TreeNode title="Victorian Working With Children" key="accreditationDowngradeVicwwc">
          <Tree.TreeNode title="New card details" key="accreditationDowngradeVicwwcIsNewCard" />
        </Tree.TreeNode>
        <Tree.TreeNode title="Conditional" key="accreditationDowngradeIsConditional" />
        <Tree.TreeNode title="Conditional on first check" key="accreditationInitialIsConditional" />
      </Tree.TreeNode>
      <Tree.TreeNode title={<Badge color="red" text="New critical issue" />} key="accreditationDowngradeRed">
        <Tree.TreeNode title="No longer current (revoked, expired)" key="accreditationDowngradeNotCurrent" />
        <Tree.TreeNode title="Not valid on first check" key="accreditationInitialNotCurrent" />
        <Tree.TreeNode title="Name mismatch on first check" key="accreditationInitialNameMismatch" />
        <Tree.TreeNode title="Conditional on first check" key="accreditationInitialIsConditional" />
      </Tree.TreeNode>
      <Tree.TreeNode title={<strong>Issue resolved</strong>} key="accreditationUpgrade" checkable={false} />
      <Tree.TreeNode title={<Badge color="yellow" text="Warning resolved" />} key="accreditationUpgradeYellow">
        <Tree.TreeNode title="Conditional" key="accreditationUpgradeIsConditional" />
        <Tree.TreeNode title="Renewed expiry" key={EXPIRY_UPGRADE_KEY} />
        <Tree.TreeNode title="Victorian Working With Children" key="accreditationUpgradeVicwwc">
          <Tree.TreeNode title="Application approved" key="accreditationUpgradeVicwwcIsApplication" />
        </Tree.TreeNode>
      </Tree.TreeNode>
      <Tree.TreeNode title={<Badge color="red" text="Critical issue resolved" />} key="accreditationUpgradeRed">
        <Tree.TreeNode title="Currency issue resolved" key="accreditationUpgradeNotCurrent" />
      </Tree.TreeNode>
    </Tree>
  )

  render() {
    const {
      userId,
      form,
      fetchOrganizationInProgress, fetchOrganizationFailed,
      patchOrganizationInProgress, patchOrganizationFailed,
      tagsItems,
      institutionsCredentials: inCreds,
    } = this.props;
    const { getFieldDecorator } = form;
    const externalIdEnabled = form.getFieldValue('externalIdEnabled');
    const institutionsCredentials = form.getFieldValue('institutionsCredentials') || (inCreds && inCreds.toJSON()) || {};

    if (institutionsCredentials.qld && institutionsCredentials.qld[userId]) {
      institutionsCredentials.qldblue = institutionsCredentials.qld[userId];
    }
    return (<Spin spinning={fetchOrganizationInProgress}>
      <BreadcrumbLevel text="Settings" />
      <BreadcrumbLevel text="General" />
      {fetchOrganizationFailed
        ? <Alert message="Couldn't get your organisation's settings right now!" /> : null}
      {patchOrganizationFailed
        ? <Alert message="Couldn't save your organisation's settings right now!" closable /> : null}
      <Form onSubmit={this.handleSubmit}>

        <h2>Notifications</h2>
        <Spin spinning={!tagsItems}>
          <h3>
            <DefinedTerm definition="An admin user is a person with a login to weareoho.com">
              Admin Users
            </DefinedTerm> receive notifications when <em>any accreditation in this organisation</em>
          </h3>
          <Form.Item>
            {getFieldDecorator('notify.user', {
              valuePropName: 'checkedKeys',
              trigger: 'onCheck',
              getValueFromEvent: value => value,
              initialValue: [],
            })(
              this.renderNotificationsTree(),
            )
            }
          </Form.Item>
          <h3>
            <DefinedTerm definition="A person is anyone who your organisation has added to weareoho.com">
              People
            </DefinedTerm> receive notifications when <em>one of their own accreditations</em>
          </h3>
          <Form.Item>
            {getFieldDecorator('notify.constituent', {
              valuePropName: 'checkedKeys',
              trigger: 'onCheck',
              getValueFromEvent: value => value,
              initialValue: [],
            })(
              this.renderNotificationsTree(),
            )
            }
          </Form.Item>
        </Spin>

        <h2>Strict Name Matching</h2>
        <p>
          Determine whether a missing middle name should be marked as invalid.
        </p>
        <Form.Item labelCol={{ span: 6 }} label="Strict Name Matching" required>
          {getFieldDecorator('strictNameMatchingEnabled', {
            valuePropName: 'checked',
            initialValue: false, //  Set default to false (light mode)
          })(
            <Switch />,
          )
          }
        </Form.Item>

        <h2>General Expiry Management</h2>
        <p>
          Enabling this feature allows you to receive expiry notifications for general accreditations.
        </p>
        <Form.Item labelCol={{ span: 6 }} label="General Expiry Management" required>
          {getFieldDecorator('genaccNotificationEnabled', {
            valuePropName: 'checked',
          })(
            <Switch />,
          )
          }
        </Form.Item>

        <h2>Display manager's email</h2>
        <p>
          Enabling this feature allows you to assign a manager's email.
        </p>
        <Form.Item labelCol={{ span: 6 }} label="Manager's email field enabled" required>
          {getFieldDecorator('managerEmailEnabled', {
            valuePropName: 'checked',
          })(
            <Switch />,
          )
          }
        </Form.Item>

        <h2>ICR Nudge Notifications</h2>
        <p>
          Configure automatic reminder notifications for incomplete Info Capture Requests (ICR).
          When enabled, applicants with pending checks will receive periodic reminder emails.
        </p>
        <Form.Item labelCol={{ span: 6 }} label="Enable ICR Nudge Notifications" required>
          {getFieldDecorator('icrNudgeEnabled', {
            valuePropName: 'checked',
            initialValue: false,
          })(
            <Switch />,
          )}
        </Form.Item>

        <div style={{ display: form.getFieldValue('icrNudgeEnabled') ? 'block' : 'none' }}>
          <Form.Item
            labelCol={{ span: 6 }}
            label="Nudge Interval (days)"
            required
            extra="Minimum interval between nudge notifications. Must be at least 2 days to prevent spam."
          >
            {getFieldDecorator('icrNudgeIntervalDays', {
              initialValue: 3,
              rules: [
                { required: true, message: 'Interval is required' },
                {
                  type: 'number',
                  min: 2,
                  message: 'Interval must be at least 2 days',
                },
              ],
            })(
              <InputNumber min={2} style={{ width: 120 }} />,
            )}
          </Form.Item>

          <Form.Item
            labelCol={{ span: 6 }}
            label="Maximum Nudges"
            required
            extra="Maximum number of nudge notifications to send per applicant before stopping."
          >
            {getFieldDecorator('icrNudgeMaxCount', {
              initialValue: 5,
              rules: [
                { required: true, message: 'Maximum count is required' },
                {
                  type: 'number',
                  min: 1,
                  max: 10,
                  message: 'Maximum must be between 1 and 10',
                },
              ],
            })(
              <InputNumber min={1} max={10} style={{ width: 120 }} />,
            )}
          </Form.Item>
        </div>

        <h2>External system links</h2>
        <p>
          Enabling this feature allows you to track a primary key in an external system.
        </p>
        <Form.Item labelCol={{ span: 6 }} label="External ID field enabled" required>
          {getFieldDecorator('externalIdEnabled', {
            valuePropName: 'checked',
          })(
            <Switch />,
          )
          }
        </Form.Item>
        {externalIdEnabled && (
          <Form.Item
            label="External system URL template"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            extra={<span>
              We will generate links in person profiles to this URL,
              replacing <code>[ID]</code> with the person's external ID.
              You may leave this field blank if you don't want to use this
              feature.
            </span>}
          >
            {getFieldDecorator('externalLinkTpl', {
            })(
              <Input />,
            )
            }
          </Form.Item>
        )}
        <h2>New ICR Form</h2>
        <p>
          Enabling this feature activates the new ICR form for your organization.
        </p>
        <Form.Item labelCol={{ span: 6 }} label="Enable New ICR Form" required>
          {getFieldDecorator('newIcrFormEnabled', {
            valuePropName: 'checked',
          })(
            <Switch />,
          )
          }
        </Form.Item>
        <h2>Aged Care Banning Order Verification</h2>
        <p>
          Enable this feature to automatically verify all constituents against the Aged Care Banning Order register.
        </p>
        <Form.Item labelCol={{ span: 6 }} label="Enable Aged Care Banning Order Verification" required>
          {getFieldDecorator('agedCareBanningOrderEnabled', {
            valuePropName: 'checked',
            initialValue: false,
          })(
            <Switch />,
          )}
        </Form.Item>

        <h2>Logo Settings</h2>
        <p>
          Upload and manage logos for your organization. Accepted formats: PNG, JPG, JPEG.
        </p>

        {!this.state.useDifferentLogos && (
          <Form.Item
            label="Organization Logo"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            extra="This logo will be used across all organization materials"
          >
            <div style={{ display: 'inline-block' }}>
              <Upload
                accept="image/png,image/jpeg,image/jpg"
                customRequest={this.handleOrganizationLogoUpload}
                onRemove={this.handleOrganizationLogoRemove}
                fileList={this.state.organizationLogoFileList}
                maxCount={1}
                listType="picture"
              >
                <Button icon="upload" loading={this.state.uploadingOrganizationLogo} disabled={this.state.uploadingOrganizationLogo}>
                  {this.state.organizationLogoUrl ? 'Replace Logo' : 'Upload Logo'}
                </Button>
              </Upload>
            </div>
          </Form.Item>
        )}

        <Form.Item
          label=" "
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          colon={false}
        >
          <Switch
            checked={this.state.useDifferentLogos}
            onChange={this.handleToggleDifferentLogos}
          />
          <span style={{ marginLeft: '8px' }}>I want to use different logos</span>
        </Form.Item>

        {this.state.useDifferentLogos && (
          <>
            <Form.Item
              label="Notification Logo"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              extra="This logo will appear in notification emails"
            >
              <div style={{ display: 'inline-block' }}>
                <Upload
                  accept="image/png,image/jpeg,image/jpg"
                  customRequest={this.handleNotificationLogoUpload}
                  onRemove={this.handleNotificationLogoRemove}
                  fileList={this.state.notificationLogoFileList}
                  maxCount={1}
                  listType="picture"
                >
                  <Button icon="upload" loading={this.state.uploadingNotificationLogo} disabled={this.state.uploadingNotificationLogo}>
                    {this.state.notificationLogoUrl ? 'Replace Logo' : 'Upload Logo'}
                  </Button>
                </Upload>
              </div>
            </Form.Item>

            <Form.Item
              label="Screening Packages Logo"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              extra="This logo will appear on screening packages"
            >
              <div style={{ display: 'inline-block' }}>
                <Upload
                  accept="image/png,image/jpeg,image/jpg"
                  customRequest={this.handleScreeningPackageLogoUpload}
                  onRemove={this.handleScreeningPackageLogoRemove}
                  fileList={this.state.screeningPackageLogoFileList}
                  maxCount={1}
                  listType="picture"
                >
                  <Button icon="upload" loading={this.state.uploadingScreeningPackageLogo} disabled={this.state.uploadingScreeningPackageLogo}>
                    {this.state.screeningPackageLogoUrl ? 'Replace Logo' : 'Upload Logo'}
                  </Button>
                </Upload>
              </div>
            </Form.Item>
          </>
        )}

        <Row justify="end" type="flex">
          <Col>
            <Button
              style={{ marginTop: '16px' }}
              loading={patchOrganizationInProgress}
              type="primary"
              htmlType="submit"
              size="large"
            >Save</Button>
          </Col>
        </Row>
      </Form>
    </Spin>);
  }
}

export const OrgSettingsPageForm = Form.create()(OrgSettingsPageComponent);

export const OrgSettingsPage = connect(
  state => ({
    userId: state.doc.getIn(['authMr', 'id'], null),
    organizationData: state.doc.getIn(['authMr', 'constituent', 'organization'], null),
    organizationSettings: state.doc.getIn(['http', 'fetchOrganizationSettingsV2', 'data'], null),
    tagsItems: state.doc.getIn(['tagsMr', 'items'], null),
    fetchOrganizationInProgress: state.doc.getIn(['http', 'fetchOrganization', 'inProgress'], true),
    fetchOrganizationFailed: state.doc.getIn(['http', 'fetchOrganization', 'failed'], false),
    fetchOrganizationEmailInProgress: state.doc.getIn(['http', 'fetchOrganizationEmail', 'inProgress'], true),
    fetchOrganizationEmailFailed: state.doc.getIn(['http', 'fetchOrganizationEmail', 'failed'], false),
    fetchOrganizationSettingsInProgress: state.doc.getIn(['http', 'fetchOrganizationSettingsV2', 'inProgress'], false),
    fetchOrganizationSettingsFailed: state.doc.getIn(['http', 'fetchOrganizationSettingsV2', 'failed'], false),
    patchOrganizationInProgress: state.doc.getIn(['http', 'patchOrganization', 'inProgress'], false),
    patchOrganizationFailed: state.doc.getIn(['http', 'patchOrganization', 'failed'], false),
    patchOrganizationSettingsInProgress: state.doc.getIn(['http', 'patchOrganizationSettingsV2', 'inProgress'], false),
    patchOrganizationSettingsFailed: state.doc.getIn(['http', 'patchOrganizationSettingsV2', 'failed'], false),
    organizationId: state.doc.getIn(['authMr', 'organizationId'], null),
    postOrganizationEmailInProgress: state.doc.getIn(['http', 'postOrganizationEmail', 'inProgress'], true),
    postOrganizationEmailFailed: state.doc.getIn(['http', 'postOrganizationEmail', 'failed'], false),
    postOrganizationCredentialsFailed: state.doc.getIn(['http', 'postOrganizationCredentials', 'failed'], false),
    organizationEmails: state.doc.getIn(['authMr', 'constituent', 'organization', 'orgEmails'], null),
    institutionsCredentials: state.doc.getIn(['authMr', 'constituent', 'organization', 'institutionsCredentials'], null),
  }),
  actions,
)(OrgSettingsPageForm);
